export default __webpack_public_path__ + "static/media/errorCheckEmpty.2b78cdd9.svg";